import React from 'react';

//WARNING: do not wrapp withStyles HOC as displayName will not be preserved
const Detail = ({ children, theme }) => {
  return(
    <div style={{marginRight: theme.spacing.unit*4}}>
      {children}
    </div>
  );
};

Detail.displayName ="Detail";

export default Detail;



// WEBPACK FOOTER //
// ./src/components/admin/ContentEdit/Detail.jsx